import * as React from "react";
import type { SVGProps } from "react";
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      fillRule="evenodd"
      d="M2.549 10c0-.23.186-.417.416-.417h14.067a.417.417 0 0 1 0 .834H2.965A.417.417 0 0 1 2.55 10"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMinus;
